import { useState, useEffect } from "react";

const useArcGISLayers = (arcGisUrl) => {
  const [layers, setLayers] = useState(null);
  const urlHttpRegexp = new RegExp(/^((http|https):\/\/)/);

  useEffect(() => {
    async function getArcGisLayers() {
      try {
        const url = urlHttpRegexp.test(arcGisUrl)
          ? arcGisUrl
          : `https://${arcGisUrl}`;

        const response = await fetch(`${url}?f=json`);
        const json = await response.json();

        setLayers(json.layers);
      } catch (err) {
        console.error(
          new Error(
            "[OLMap] - could not fetch layers from ArcGIS map server:",
            err
          )
        );
      }
    }

    if (arcGisUrl) getArcGisLayers();
  }, [arcGisUrl]);

  return layers || [];
};

export default useArcGISLayers;
